/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
"use client";
import { Box, Button, Card, Modal, Stack, Typography } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import NextLink from "next/link";
import { useDispatch, useSelector } from "react-redux";
import AudioPlayer from "../../components/AudioPlayer";
import { SocialShare } from "../../components/FBSocial";
import Iconify from '../../components/Iconify';
import Markdown from "../../components/Markdown";
import { PreviewYoutube } from "../../components/YoutubePlayer";
import useLocales from "../../hooks/useLocales";
import useResponsive from "../../hooks/useResponsive";
import { removeSituationAnswer, setAnswered, setHint } from "../../redux/slices/gplx.situation.slice";
import CommentList from "../comment/CommentList";
import CommentNewForm from "../comment/CommentNewForm";
import VideoPlayerPreview from "./VideoPlayerPreview";

const style = {
  position: 'absolute',
  bgcolor: 'background.paper',
  boxShadow: 24,
  width: "100%",
  p: 2,
  margin: 0
};

function VideoSection({ item, prevItem, nextItem }) {
  let theme = useTheme();
  const { translate } = useLocales();

  const dispatch = useDispatch();
  const { answers, isAnswered, hint } = useSelector((state) => state.situation);
  const isDesktop = useResponsive('up', 'sm');

  const currentAnswer = answers?.find(a => a.id === item.id);

  const spaceHandle = () => {
    if (isAnswered) {
      dispatch(setAnswered(false));
      dispatch(removeSituationAnswer(item));
    } else
      dispatch(setAnswered(true));
  };

  const handleCloseHint = () => {
    dispatch(setHint(false));
  };

  const handleOpenHint = () => {
    dispatch(setHint(true));
  };

  return (
    <Stack spacing={1} sx={{ position: 'relative' }}>
      <VideoPlayerPreview video={item} prevItem={prevItem} nextItem={nextItem} />
      <Modal disablePortal open={hint || false} onClose={handleCloseHint} style={{ position: 'absolute' }}>
        <Box sx={{ ...style }} >
          <Markdown children={item.description} />
          <AudioPlayer text={item.description} />
          <Button onClick={handleCloseHint} sx={{ px: 5, float: 'right' }} color="warning" variant="contained" size="medium" >{hint ? "Ẩn gợi ý" : "Gợi ý"}</Button>
        </Box>
      </Modal>
      <Typography variant="subtitle1" fontWeight={500} color={"error"}>{item.title}</Typography>
      {isDesktop && <Typography variant="body2" textAlign={"center"} > {translate("situation.guide")}</Typography>}

      <Stack direction={"row"} bgcolor={theme.palette.background.neutral} spacing={5} px={0} alignItems={"center"}>
        <Typography flex={1} variant="subtitle1">Đã làm: {answers?.length}/120</Typography>
        <Typography flex={1} variant="subtitle1">Điểm: {currentAnswer?.score} ( {currentAnswer && (Math.round(currentAnswer?.seletedTime * 10) / 10)}s)</Typography>
        <Button onClick={handleOpenHint} color="warning" sx={{ px: isDesktop ? 5 : 1 }} variant="contained" size="medium" >{hint ? "Ẩn gợi ý" : "Gợi ý"}</Button>
      </Stack>

      <Stack direction={"row"} spacing={1}>
        <NextLink href={`/thi-tinh-huong/${prevItem?.slug}`} passHref scroll={false}>
          <Button disabled={!prevItem} variant="outlined" size="large" startIcon={<Iconify icon={'material-symbols:arrow-back-ios'} />} />
        </NextLink>
        {!isAnswered && <Button onClick={spaceHandle} fullWidth variant="contained" size="large"> SPACE (Phím cách)</Button>}
        {isAnswered && <Button color="warning" onClick={spaceHandle} fullWidth variant="contained" size="large"> Làm lại</Button>}
        <NextLink href={`/thi-tinh-huong/${nextItem?.slug}`} passHref scroll={false}>
          <Button disabled={!nextItem} variant="outlined" size="large" endIcon={<Iconify icon={'material-symbols:arrow-forward-ios'} />} />
        </NextLink>
      </Stack>
      {item && <>
        <SocialShare title={item.title} />
        <Typography variant="subtitle1">GỢI Ý 120 TÌNH HUỐNG MÔ PHỎNG TỔNG HỢP</Typography>
        <PreviewYoutube videoId={"sUM8LgbJnMA"} autoplay={false} />
        <Score />
        <Stack sx={{ display: 'flex', mb: 2 }}>
          <Typography variant="h4">{translate("button.comment")}</Typography>
          <Typography variant="caption">Ấn SPACE trước khi bình luận nhé</Typography>
        </Stack>
        <CommentNewForm itemId={item?.orderNo} type="SITUATION" />
        <CommentList />
      </>}
    </Stack >
  );
}

function Score() {
  return (<Card><Stack spacing={1} p={2}>
    <Typography variant="subtitle1">PHƯƠNG PHÁP CHẤM ĐIỂM</Typography>
    <Typography variant="body1">Trong mỗi tình huống có 02 mốc thời điểm 5đ và 0đ:</Typography>
    <Typography variant="body1"><strong>+ 5 điểm:</strong> thời điểm bắt đầu có dấu hiệu phát hiện ra tình huống nguy hiểm, lái xe cần xử lý.</Typography>
    <Typography variant="body1"><strong>+ 0 điểm:</strong> mốc thời điểm mà xử lý từ thời điểm này vẫn xảy ra tai nạn</Typography>
    <Typography variant="body1"> Học viên lựa chọn được giữa 2 mốc này sẽ đạt mức điểm tương ứng từ <strong>5-4-3-2-1 điểm</strong> (điểm tối đa cho mỗi tình huống là 5đ).</Typography>
  </Stack></Card>);
}

export default VideoSection;
